<template>
  <div>
    <div class="contant-wrap">
      <h4>版本更新常见问题解答</h4>
      <el-collapse v-model="activeName" accordion class="help-info">
        <el-collapse-item title="主要功能变更" name="1">
          <div class="title">数据安全：</div>
          <div>-升级前的所有数据均将保留，不会有任何数据丢失。</div>
          <div>-所有登录账号、密码均和以前一致</div>
          <div class="title mt10">功能新增：</div>
          <div>-“历史病历”：可以查看医生所开具的所有病历、处方</div>
          <div>-“流向查询”：可以查看任意药品的入库、出库完整记录</div>
          <div>-“盘点管理”：可以对当前库存进行修订，所有盘点记录不可删除。</div>
          <div>-“会员管理”：可以给患者贴标签、发优惠券、发短信</div>
          <div class="title mt10">功能移除：</div>
          <div>-“挂号”：由于使用率较低，暂时移除</div>
          <div>-“医院转诊”：由于使用率较低，暂时移除</div>
          <div class="title mt10">功能变更：</div>
          <div>-“门诊处方”和“门诊病历”功能合并，现在统一入口为“门诊处方”。</div>
          <div>-“药品入库”升级为“采购管理”：不仅能做入库操作，还能进行入出库记录查询和退货。</div>
        </el-collapse-item>
        <el-collapse-item title="如何设置打印机？" name="1-1">
          <div class="title">请点击查看 <a target="target" style="color: #66b1ff;" href="https://shimo.im/docs/hFkkj8SU8MUXXT6m/">如何设置打印机？</a></div>
        </el-collapse-item>
        <el-collapse-item title="“门诊”有什么变动？" name="2">
          <div>1.整个门诊处方与门诊病历合并（所有输入项都保存了，合并了门诊病历和门诊处方的重复功能）；</div>
          <div>2.门诊右侧的"检查治疗项"移到门诊病历的主页中；</div>
          <div>3."既往史""个人史""过敏史""家族史"和“体格检查”等不常填写的输入项默认收缩；</div>
          <div>4.原“门诊病历”右侧的AI诊疗功能正在重做，后续将重新上线；</div>
          <div>5.删除了原有的“就诊类型”选择（初诊、复诊）选择项</div>
          <div>6.删除了原有的“随访时间”设置</div>
          <div>7.“今日就诊”模块正在重做，后续将重新上线</div>
        </el-collapse-item>
        <el-collapse-item title="“直接售药”有什么变动？" name="3">
          <div>1.新增开药医生，方便记录医生销售统计；</div>
          <div>2.新增抹零和优惠券核销功能；</div>
          <div>3. “添加检查治疗项” “添加附加费用”默认隐藏；</div>
          <div>4.售药列表新增药品库存、货架码和批号字段：</div>
          <div class="ml10">
            <div>a)库存的展示，诊所售药时可根据药品的库存情况，及时选择最优方案；</div>
            <div>b)货架码的展示，方便售药人员及时找到对应药品；</div>
            <div>c)批号展示，默认按照先进先出的规则销售，诊所也可以根据实际情况，手动改选销售药品的批号，诊所可实现对药品批号的管理。</div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="“药品信息管理”有什么变动？" name="4">
          <div>1.新增【快速编辑】功能，该功能可方便诊所快捷编辑药品价格、货架码和库存阈值。</div>
          <div>2.新增药品界面规范规格输写，药品可添加多级包装单位以及设置多种零售价格。</div>
        </el-collapse-item>
        <el-collapse-item title="新增的“采购管理”怎么用？" name="5">
          <div>新增的【采购管理】方便诊所进行采购入库、采购退货以及出入库记录查询：</div>
          <div>1.入库单保存后，效期和批号不可修改(比原有系统更加严谨)，可在入库单列表查询每个入库单的详情以及备注；</div>
          <div>2.采购退货可在采购入库单上操作采购退货记录，更加符合交易场景。</div>
        </el-collapse-item>
        <el-collapse-item title="新增的“库存盘点”怎么用？" name="6">
          <div>新增的【库存盘点】可对库存进行即时校准。每次盘点时，需"新建盘点单"，新建盘点单时，所有药品锁定保证盘点准确性；盘点可根据诊所需求选择是否按批号进行盘点。</div>
        </el-collapse-item>
        <el-collapse-item title="新增的“流向查询”怎么用？" name="7">
          <div>新增的【流向查询】，可以筛选和查询每个药品的进销存及调整（盘点）情况，每个药品的采购入库(含入库时间批号单价金额)、采购退货、库存调整(盘点)、销售出库、销售退货等，并支持多维度查询，方便诊所收集数据、分析数据。</div>
        </el-collapse-item>
        <el-collapse-item title="现在的“统计”有什么变动？" name="8">
          <div>1.统计模块添加图形图标，更加直观展示起数据变化曲线；</div>
          <div>2.【财务统计】展示选定时间范围内，所有资金变动。</div>
          <div>3.【订单统计】展示选定时间范围内，所有门诊交易额和直接售药交易额之和。</div>
          <div>4.新增的【药品统计】功能，查看诊所所有药品的销售情况，可设置根据药品销量或者利润进行排序。</div>
        </el-collapse-item>
        <el-collapse-item title="新增的“会员管理”怎么用？" name="9">
          <div>1.给每个用户赋予专属标签，批量管理不同用户画像，更佳智能化、人性化。两种标签形式</div>
          <div class="ml10">
            <div>a)自动标签：系统通过预设的条件判断患者所符合的标签，自动给患者赋予标签；</div>
            <div>b)手动标签：系统收集常见标签，诊所给患者手动赋予的标签。</div>
          </div>
          <div>2.搭配专属微信小程序，患者可通过小程序上实现付款，共同维护平台会员。</div>
          <div>3.可给患者群发送短信或优惠券，点对点对患者进行关怀式营销，提供多个节假日短信模板。</div>
          <div>4.一键导入、导出会员数据，管理会员更轻松，更快捷。</div>
        </el-collapse-item>
        <img class="info-img" src="/img/1.png">
      </el-collapse>
    </div>
    
  </div>
</template>


<script>
export default {
  data() {
    return {
      activeName: '',
    }
  },
  methods: {
    
  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
  h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .info-img {
    margin-top: 15px;
    width: 100%;
  }
  .title {
    font-weight: bold;
  }
  .mt10 {
    margin-top: 10px;
  }
  .ml10 {
    margin-left: 10px;
  }
  
</style>